import { useTranslation } from 'react-i18next';
import { useGenericMutation } from '@hooks/use-generic-mutation';
import { useToast } from '@hooks/use-toast/use-toast';
import { request } from '@utils/request/request';
import { RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants.type';
import type {
  BulkImportPassHoldersArguments,
  BulkImportPassHoldersFormData,
  BulkImportPassHoldersResponse,
} from './use-bulk-import-pass-holders.type';

const bulkImportPassHolders = async (passId: string, formData: BulkImportPassHoldersFormData) => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/passes/${passId}/bulk-import`;
  return request({ url, method: RequestMethod.POST, body: formData });
};

export const useBulkImportPassHolders = ({ hideToast }: { hideToast?: boolean }) => {
  const { t } = useTranslation();
  const toast = useToast();

  return useGenericMutation(
    [QUERY_KEYS.bulkImportPassHolders],
    async ({ passId, importData }: BulkImportPassHoldersArguments): Promise<BulkImportPassHoldersResponse> =>
      bulkImportPassHolders(passId, importData),
    {
      onSuccess: hideToast
        ? () => {}
        : () => {
            toast.push({
              title: t('passes:bulkImportSuccessNotificationTitle'),
              text: '',
              type: 'success',
            });
          },
    }
  );
};
